import { textSize, titleFont } from '@portal/kit/pkg/styles'

const titleStyles = {
  title: {
    marginTop: -3,
    marginBottom: 3,
    ...textSize(16, 31),
    ...titleFont(),
    textAlign: 'center',
    textTransform: 'uppercase',
  }
}

export default titleStyles
